import { InfoIcon } from 'lucide-react'

import {
  Feedback,
  FeedbackContent,
  FeedbackDescription,
  FeedbackLayout,
  FeedbackTitle,
} from '@/components/ui/feedback'
import useTranslator from '@/hooks/translation'

interface FeedbackNoChangesProps {
  layout?: FeedbackLayout
  className?: string
}

export function FeedbackNoChanges({
  layout = 'compact',
  className,
}: FeedbackNoChangesProps) {
  const { getTranslation } = useTranslator()

  const title = getTranslation('common.messages.noChanges.title')

  const description = getTranslation('common.messages.noChanges.description')

  return (
    <Feedback layout={layout} variant="info" className={className}>
      {/* TODO: Add no changes image when available */}
      {/* <FeedbackImage src="" alt="No Changes" /> */}

      <FeedbackContent>
        <FeedbackTitle>
          {layout === 'compact' && <InfoIcon />}
          {title}
        </FeedbackTitle>

        <FeedbackDescription>{description}</FeedbackDescription>
      </FeedbackContent>
    </Feedback>
  )
}
